<template lang="pug">
    div.coverPhotoWrapper
        div.uploadWrapper
            div
                v-btn.btnUpload.uploadButton(
                    color="primary"
                    large
                    id="avatar"
                    :isLoading="isLoading"
                    :disabled="isLoading"
                )
                    span {{ $t('defaultButtons.uploadImage') }}
                    input(
                        type="file"
                        @change="uploadImage"
                        accept="image/jpeg,image/png,image/jpg"
                    )

            div.fileName(v-if="model.owner.avatar_name") {{ model.owner.avatar_name }}

                // Remove button
                a.removeButton(@click="removeCoverPhoto")
                    v-icon(size="16" color="white") close
</template>

<script>
    import ImageCompressor from 'image-compressor.js';
    import { mapActions } from 'vuex';
    import { mapFields } from 'vuex-map-fields';

    export default {
        data() {
            return {
                isLoading: false,
                file: {
                    name: null,
                    base64: null
                }
            };
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            })
        },
        methods: {
            ...mapActions('businesses', ['uploadAvatar', 'removeAvatar']),
            uploadImage(e) {
                let self = this;
                let image = e.target.files[0];

                // Clear file value if upload the same file
                document.querySelector('#avatar input').value = '';

                const toBase64 = file =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            this.uploadAvatar({
                                avatar: reader.result,
                                avatar_name: file.name,
                                userId:
                                    this.model.owner && this.model.owner.id
                                        ? this.model.owner.id
                                        : ''
                            });
                            return resolve(reader.result);
                        };
                        reader.onerror = error => reject(error);
                    });

                // Set image data into model
                async function setImage() {
                    // Compress image
                    new ImageCompressor(image, {
                        quality: 0.6,
                        width: 225,
                        async success(result) {
                            // Convert image to base64
                            self.model.owner.avatar = self.file.base64 = await toBase64(
                                result
                            );

                            return result;
                        },
                        error(e) {
                            console.log(e.message);
                        }
                    });
                }

                if (image.name) {
                    this.model.owner.avatar_name = self.file.name = image.name;
                    // Compress and set base64 into model
                    setImage();
                }
            },
            /**
             * Remove cover photo
             */
            removeCoverPhoto() {
                this.model.owner.avatar_name = this.file.name = null;
                this.model.owner.avatar = this.file.base64 = null;

                this.removeAvatar(this.model.owner.id);
            }
        }
    };
</script>
<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .btnUpload
        cursor: pointer
        position: relative
        overflow: hidden
        min-width: 160px
        width: auto
        margin: 0 15px 0 0
        border-radius: 0
        padding: 0 35px
        font-weight: 400
        box-shadow: none !important

    .btnUpload input[type=file]
        position: absolute
        height: 44px;
        top: -13px;
        width: calc(100% + 70px);
        left: -35px;
        text-align: right
        opacity: 0
        outline: none
        cursor: inherit
        display: block

    .coverPhotoWrapper
        margin-top: 12px

    .uploadWrapper
        display: flex
        align-items: center

    .removeButton
        padding-left: 5px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .uploadWrapper
            flex-direction: column
            align-items: flex-start

        .fileName
            margin-top: 10px
</style>
